import { Switch, Route ,Redirect  } from "react-router-dom";
import LogIn from "../pages/LogIn";
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ForgotPassword/ResetPassword'
import { ROOT, LOGIN,
  FORGOT_PASSWORD, RESET_PASSWORD ,DASHBOARD,ADDSTUDENT ,STUDENTS_LIST,FEE_SETUP, STUDENTS_DETAILS} from "./constants";
import Dashboard from "../components/Dashboard";
import AddStudent from "../components/Student/AddStudent";
import StudentList from "../components/Student/List";
import FeeSetup from "../components/Fees/FeeSetup";
import '../assets/css/style.css';
import '../assets/css/responsive.css';
import PendingRegistration from "../components/Student/PendingRegistration";
import PaymentDue from "../components/Student/PaymentDue";
import AdmissionForward from "../components/Student/List/admissionForward";
import Admission from "../components/Student/List/admission";
import PaymentStatus from "../components/Student/PaymentDue/PaymentStatus";
import Notification from "../components/Notification";
import PaymentsList from "../components/PaymentsLIst";
import EditProfile from "../components/Student/Edit";
import ReportsList from "../components/Reports";
import PendingPayments from "../components/PendingPayments";

export const RouterConfig = () => {
  return (
    <div>
      <Switch>
        {/* List all public routes here */}
        <Route exact path={ROOT} >
             <Redirect to={DASHBOARD} />
        </Route>
        <Route exact path={DASHBOARD} component={Dashboard} />
        <Route exact path={ADDSTUDENT} component={AddStudent} />
        <Route exact path={STUDENTS_LIST} component={StudentList} />
        <Route exact path={FEE_SETUP} component={FeeSetup} />
        <Route exact path="/pendingRegistration" component={PendingRegistration} />
        <Route exact path="/profilePending/:id" component={AddStudent} />
        <Route exact path="/paymentDue" component={PaymentDue} />
        <Route exact path="/paymentDue/student/:id" component={PaymentDue} />
        <Route exact path="/studentsList/admissionForward/:id" component={Admission} />
        <Route exact path="/payment/status/:id" component={PaymentStatus} />
        <Route exact path="/notifications" component={Notification} />
        <Route exact path="/paymentsList" component={PaymentsList} />
        <Route exact path={STUDENTS_DETAILS} component={EditProfile} />
        <Route exact path="/reports" component={ReportsList} />
        <Route exact path="/pendingPayments" component={PendingPayments} />
        <Route exact path="*">
          <Redirect to={DASHBOARD} />
        </Route>
      </Switch>
    </div>
  );
};


export const UnAuthenticatedRoutes = () => {
  return (
    <div>
      <Switch>
        {/* List all public routes here */}
        <Route exact path={ROOT} component={LogIn} >
          <Redirect to={LOGIN} />
        </Route>
        <Route exact path={FORGOT_PASSWORD} component={ForgotPassword} />
        <Route  exact path={RESET_PASSWORD} component={ResetPassword} />
        <Route path={LOGIN}>
          <LogIn />
        </Route>
        <Redirect to={ROOT}  />
      </Switch>
    </div>
  );
};
